module.exports = __webpack_public_path__ + "static/media/Settings_Divider@3x.bd8c38e1.png";